import React, { useEffect, useState } from "react";
import VoucherTableComponent from "./VoucherTable.component";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { hideBackdrop, showBackdrop } from "../../../../backdrop";
import { getApiLang, getLang } from "../../../../../app/feature/constants";
import AlertIcon from "../../../../../assets/svg/alert.svg";
import GeneralDialog from "../../../../../components/dialog/generalDialog";
import { AccessRights } from "../../../../../lib/constants/accessRights";
import { canAccess } from "../../../../profile/redux/selector/profile.selector";
// import {
//   VOUCHER_ADD,
//   VOUCHER_DELETE,
//   VOUCHER_EDIT,
// } from "../../../../../lib/constants/accessRights";
import surveyApi from "../../../../../app/api/survey";
import { addAlert } from "../../../../notification";

const VoucherTableContainer = ({
  classes,
  lang,
  timezone,
  setIsAdding,
  selectedSurvey,
}) => {
  const dispatch = useDispatch();

  const canEditVoucher = useSelector((state) =>
    canAccess(state, AccessRights.Survey.VOUCHER_WRITE_UPDATE)
  );
  const canAddVoucher = useSelector((state) =>
    canAccess(state, AccessRights.Survey.VOUCHER_WRITE_CREATE)
  );
  const canDeleteVoucher = useSelector((state) =>
    canAccess(state, AccessRights.Survey.VOUCHER_WRITE_DELETE)
  );

  const initialFilter = {
    searchBy: "voucher_code",
    searchText: "",
    startDate: null,
    endDate: null,
    status: -1,
  };

  const [listing, setListing] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFetching, setIsFetching] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const [filter, setFilter] = useState(initialFilter);

  const [deleting, setDeleting] = useState(null);

  const [totalAvailable, setTotalAvailable] = useState(0);
  const [totalIssued, setTotalIssued] = useState(0);

  const fetchData = async () => {
    setIsFetching(true);

    const {
      success,
      data: { vouchers, recordsFiltered, totalAvailable, totalIssued },
      code,
    } = await surveyApi.fetchVoucherListing({
      uuid: selectedSurvey,
      page,
      length: rowsPerPage,
      ...filter,
      status: filter.status === -1 ? "" : filter.status,
      search: filter.searchText,
      searchBy: filter.searchBy,
    });

    if (success) {
      setListing(vouchers);
      setTotalRecords(recordsFiltered);
      setTotalAvailable(totalAvailable);
      setTotalIssued(totalIssued);
      setIsFetching(false);
    } else {
      dispatch(
        addAlert({
          severity: success ? "success" : "error",
          message: getApiLang(lang, code),
        })
      );
      setListing([]);
      setTotalRecords(0);
      setTotalAvailable(0);
      setTotalIssued(0);
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const handleSearch = (values) => {
    setPage(0);

    setFilter({
      ...values,
      startDate: values.startDate
        ? moment(values.startDate).startOf("day").toISOString()
        : "",
      endDate: values.endDate
        ? moment(values.endDate).endOf("day").toISOString()
        : "",
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);

    fetchData();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);

    fetchData();
  };

  const handleExport = async (format) => {
    dispatch(showBackdrop());

    const blobData = await surveyApi.exportVoucherListing({
      uuid: selectedSurvey,
      fileType: format,
    });

    if (blobData) {
      const url = window.URL.createObjectURL(new Blob([blobData.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", blobData.fileName);
      document.body.appendChild(link);
      link.click();

      // Clean up
      link.remove();
      window.URL.revokeObjectURL(url);
    }

    dispatch(hideBackdrop());
  };

  const handleClickDelete = (uuid) => {
    setDeleting(uuid);
  };

  const handleDelete = async () => {
    setPage(0);
    dispatch(showBackdrop());

    const { success, code } = await surveyApi
      .deleteVoucher({
        uuid: selectedSurvey,
        voucherUuid: deleting,
      })
      .catch((error) => error);

    if (!success) {
      dispatch(
        addAlert({
          severity: success ? "success" : "error",
          message: getApiLang(lang, code),
        })
      );
    }

    setDeleting(null);
    dispatch(hideBackdrop());
    fetchData();
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <VoucherTableComponent
        classes={classes}
        lang={lang}
        listing={listing}
        totalRecords={totalRecords}
        isFetching={isFetching}
        page={page}
        rowsPerPage={rowsPerPage}
        timezone={timezone}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        setIsAdding={setIsAdding}
        handleExport={handleExport}
        handleSearch={handleSearch}
        filter={initialFilter}
        handleClickDelete={handleClickDelete}
        canAddVoucher={canAddVoucher}
        canEditVoucher={canEditVoucher}
        canDeleteVoucher={canDeleteVoucher}
        totalAvailable={totalAvailable}
        totalIssued={totalIssued}
      />
      <GeneralDialog
        isOpen={!!deleting}
        handleClose={() => setDeleting(null)}
        handleProceed={handleDelete}
        title={getLang(lang, "label.DELETE_VOUCHER")}
        description={getLang(lang, "paragraph.DELETE_VOUCHER")}
        type="danger"
        icon={<img src={AlertIcon} alt="alert" />}
      />
    </MuiPickersUtilsProvider>
  );
};

export default VoucherTableContainer;
